import { render, staticRenderFns } from "./analysis-notes-and-history.vue?vue&type=template&id=24b4809b"
import script from "./analysis-notes-and-history.vue?vue&type=script&lang=ts"
export * from "./analysis-notes-and-history.vue?vue&type=script&lang=ts"
import style0 from "./analysis-notes-and-history.vue?vue&type=style&index=0&id=24b4809b&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b4809b')) {
      api.createRecord('24b4809b', component.options)
    } else {
      api.reload('24b4809b', component.options)
    }
    module.hot.accept("./analysis-notes-and-history.vue?vue&type=template&id=24b4809b", function () {
      api.rerender('24b4809b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/analysis/edit-analysis/edit-analysis-admin/analysis-notes-and-history.vue"
export default component.exports